import React, { forwardRef, useImperativeHandle } from "react";
import { Layout, Typography, Table, Col } from "antd";
import DpatSubIndicatorSection from "../setup/DpatSubIndicatorSection";
import DpatIndicatorCmsIntro from "../setup/DpatIndicatorCmsIntro";
import Comment from "components/Comments";
import CiResultDisplay from "./CiResultDisplay";
import { resolveMeetingDataProp } from "utils/dpatAssessmentStartData";
import { transformDpatTableRows } from "utils/renderDpatEvidenceLink";
const { Title, Text } = Typography;
const { Content } = Layout;

const ExecutiveCommitteeMember = forwardRef(({
  data,
  year,
  columns,
  districtId,
  hideComment,
  savedAssessmentData,
  assessmentStartLoading,
  isAssessmentStarted,
}, ref) => {
  const displayData = resolveMeetingDataProp({
    isAssessmentStarted,
    savedAssessmentData,
    liveData: data,
  });

  const DPAT_SLUG = "c2.0-2.1";

  const MEETING_LINK_KEYS = ["docs", "attendance", "recommendation"];

  useImperativeHandle(ref, () => ({
    getData: () => ({
      indicator: "CI2",
      area: "Other Statutory Meetings / Requirements",
      data
    }),
  }));

  return (
    <Comment
      data={data}
      year={year}
      districtId={districtId}
      tableCommentedId={`c2.0-2.1-${year}`}
      hideComment={hideComment}
    >
      {({ renderCommentFeedbackFooter }) => (
          <DpatSubIndicatorSection code={DPAT_SLUG}>
          <DpatIndicatorCmsIntro
            year={year}
            slug={DPAT_SLUG}
          />

          <Col align="start">
            <CiResultDisplay slug={DPAT_SLUG} fulfillment={displayData?.fulfillment} />
</Col>

          <Title level={4} style={{ marginTop: "20px" }}>Evidence of Executive Committee Meeting</Title>
          {assessmentStartLoading && <Text>Loading saved assessment data…</Text>}

          {/* Always render the table, prioritizing endpointData over prop data */}
          <Table
            columns={columns}
            dataSource={transformDpatTableRows(displayData?.data || [], MEETING_LINK_KEYS)}
            pagination={false}
            bordered
            rowKey={(record, index) => `${record.key || index}`}
          />
            {!hideComment && renderCommentFeedbackFooter()}
          </DpatSubIndicatorSection>
      )}
    </Comment>
  );
});

export default ExecutiveCommitteeMember;